import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import GuideMessage from 'components/stateless/GuideMessage/GuideMessage';
import Tab from 'components/stateless/TabManager/Tab';
import { HeaderTitle } from 'components/stateless/Title/HeaderTitle';

import AnchorInvoiceListDeletedTab from './tabs/AnchorInvoiceListDeletedTab';
import AnchorInvoiceListRegisteredTab from './tabs/AnchorInvoiceListRegisteredTab';
import useAnchorInvoiceListController from './useAnchorInvoiceListController';

function AnchorInvoiceList() {
  const { t } = useTranslation(['format']);
  const {
    registeredInvoicePage,
    deletedInvoicePage,
    registeredInvoiceSearchForm,
    deletedInvoiceSearchForm,
    registeredListPageable,
    deletedListPageable,
    handleClickRegisteredInvoiceSearch,
    paginateRegisteredInvoiceList,
    handleClickDeletedInvoiceSearch,
    paginateDeletedInvoiceList,
  } = useAnchorInvoiceListController();

  return (
    <>
      <HeaderTitle title={t('text:Invoice')} />
      <GuideMessage
        message={[
          t('text:Invoices_that_wait_for_approval_or_are_registered_can_be_found_on_the_Registered_tab'),
          t('text:Invoices_deleted_by_anchor_authorizer_after_approval_is_completed_are_available_on_the_Deleted_tab'),
        ]}
      />

      <Tab
        initialActiveTabIndex={0}
        tabList={[
          {
            tabName: t('text:Registered'),
            tabItemCount: registeredInvoicePage?.totalElements ?? 0,
          },
          {
            tabName: t('text:Deleted'),
            tabItemCount: deletedInvoicePage?.totalElements ?? 0,
          },
        ]}
        tabViewList={[
          <FormProvider {...registeredInvoiceSearchForm} key="registered">
            <AnchorInvoiceListRegisteredTab
              invoicePage={registeredInvoicePage}
              pageable={registeredListPageable}
              paginate={paginateRegisteredInvoiceList}
              handleClickSearch={handleClickRegisteredInvoiceSearch}
            />
          </FormProvider>,
          <FormProvider {...deletedInvoiceSearchForm} key="registered">
            <AnchorInvoiceListDeletedTab
              invoicePage={deletedInvoicePage}
              pageable={deletedListPageable}
              paginate={paginateDeletedInvoiceList}
              handleClickSearch={handleClickDeletedInvoiceSearch}
            />
          </FormProvider>,
        ]}
      />
    </>
  );
}

export default AnchorInvoiceList;
